import { Button, useTheme } from '@mui/material';
import { Layout } from 'plotly.js';
import { useTranslation } from 'react-i18next';

import { Plot } from '@/monitoring/plots/Plot';
import { CommuteUtils } from '@/monitoring/utils/CommuteUtils';
import { HandleDownload } from '@/services/DownloadHandler';
import { MonitoringAnalysisData } from '@/services/api';

type ModalSplitProps = {
  data: MonitoringAnalysisData[];
  showSubtitle?: boolean;
  disableDownloadButton?: boolean;
  layout?: Partial<Layout>;
  centerLegend?: boolean;
};

export function ModalSplitPlot({ data, showSubtitle, disableDownloadButton, layout, centerLegend }: ModalSplitProps) {
  const theme = useTheme();

  const { t, i18n } = useTranslation();

  const plotData = data.filter((obj) => obj.count > 0);
  const filterdData = [
    {
      values: plotData.map((obj) => obj.count),
      labels: plotData.map((obj) => t(`CommuteTypeShort.${obj.commuteType}`)),
      type: 'pie',
      hole: 0.7,
      sort: false,
      texttemplate: '%{percent:.0%}',
      marker: {
        colors: plotData.map((obj) => CommuteUtils[obj.commuteType].color),
        line: {
          color: theme.palette.tertiary.light,
          width: 1,
        },
      },
      hoverinfo: 'label+value+percent',
    },
  ];

  const header = ['Verkehrsmittel', 'Anteil', 'in Prozent'];
  const csvData = filterdData.flatMap((param) => {
    const total = param.values.reduce((acc, currentValue) => acc + currentValue, 0);

    return param.values.map((value, index) => ({
      label: param.labels[index],
      values: value,
      percent: Number(((value / total) * 100).toFixed(1)).toLocaleString('de-DE'),
    }));
  });

  return (
    <>
      {!disableDownloadButton && (
        <Button onClick={() => HandleDownload({ csvData, header, name: 'Verkehrsmittelnutzung' })}>Download CSV</Button>
      )}
      <Plot
        data={filterdData as any}
        layout={{
          ...layout,
          title: {
            text: t('MonitoringAnalysisModalSplitTitle'),
            subtitle: { text: showSubtitle ? t('MonitoringAnalysisModalSplitSubtitle') : '&nbsp;' },
          },
          showlegend: true,
          ...(centerLegend && { legend: { x: 0.5, y: 0.5, xanchor: 'center' } }),
        }}
        useResizeHandler
        style={{ width: '100%', height: '100%' }}
        config={{ locale: i18n.language }}
      />
    </>
  );
}
